---
date: 2023-07-31
title: A JOSM plugin
---

A [JOSM][] plugin is now available to preview your changes in indoor=.
Install it directly from JOSM or [head over to the repository](https://github.com/indoorequal/indoorequal-josm-plugin).

[JOSM]: https://josm.openstreetmap.de/
